import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addNCRoot } from "../redux/actions/index";

const useAddNCRoot = (el) => {
  const dispatch = useDispatch();
  const isConnected = useSelector(state => state.isConnected);
  useEffect(() => {
    dispatch(addNCRoot(el));
  }, [isConnected, dispatch, el])
  return null;
};

export default useAddNCRoot;
